import { useSelector } from 'react-redux';
import { IconButton, List, Typography } from '@mui/material';
import usePagination from '@mui/material/usePagination/usePagination';
import { Box } from '@mui/system';

import isEmpty from 'Lib/utilities/isEmpty';
import { screenSize } from 'Lib/utilities/screenSize';

export default function Pagination({ pagination, onPageChange }) {
	const { page, totalPages } = pagination;

	const { items } = usePagination({
		page: Number(page),
		count: Number(totalPages),
		onChange: (__, page) => onPageChange(page)
	});
	const previousPage = items[0];
	const nextPage = items[items.length - 1];

	const { mobile } = screenSize();

	const pageSize = useSelector(state => state.ui.table.pageSize) || pagination.pageSize;

	return isEmpty(pagination) || pageSize == 9999 ? (
		<Box sx={{ py: 6 }} />
	) : (
		<Box sx={{ display: 'flex', justifyContent: 'flex-end', pr: { xs: 0, sm: mobile ? 0 : 4 } }}>
			<List
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					width: '100%',
					boxShadow: '0px -4px 7px rgba(0, 0, 0, 0.15)',
					bgcolor: 'common.white'
				}}>
				<IconButton {...previousPage} sx={{ ml: 1 }}>
					arrow_back_ios_new
				</IconButton>
				<Typography sx={{ display: 'flex', flexGrow: 2, alignSelf: 'center', justifyContent: 'center' }}>
					Page {totalPages > 0 ? page : 0} of {totalPages}
				</Typography>
				<IconButton {...nextPage} sx={{ mr: 1 }}>
					arrow_forward_ios
				</IconButton>
			</List>
		</Box>
	);
}
